import { SiteDictionary } from '@/lib/dictionary';

const en: SiteDictionary = {
  generic: {
    actions: {
      scrollLeft: 'Scroll left',
      scrollRight: 'Scroll right',
      goBack: 'Back',
      close: 'Close',
      addBookmark: 'Save',
      removeBookmark: 'Saved to bookmarks',
      showLess: 'Show less',
      showMore: 'Show more',
      openPDF: 'Open PDF file',
      openMenu: 'Open menu',
      scrollToTop: 'Back to top',
      listenTranscription: 'Listen to the article',
      share: 'Share',
      remove: 'Delete all',
      show: 'Show',
      filter: 'Filter',
      closeMessage: 'Close notification',
    },
  },
  components: {
    menu: {
      campaign: 'Campaign!',
      servicesAndProducts: 'Services',
      backgroundInformation: 'Credit Information',
      debtRegister: 'Debt Register',
      marketReview: 'Market Reviews',
      marketingLists: 'Marketing Lists',
      salesAgent: 'Sales Agent',
      certificates: 'Certificates',
      api: 'Data Integrations',
      pricingPackages: 'Pricing Plans',
      blog: 'Blog',
      aboutUs: 'About us',
      contact: 'Contact',
      termsOfService: 'Terms of Use',
      consultation: 'Would you like a free consultation and an Infobank demo?',
      booking: 'Book',
    },
    intro: {
      title: 'All about Estonian companies',
      creditInformation: 'Credit Information',
      debtRegister: 'Debt Register',
      marketingLists: 'Marketing Lists',
      salesAgent: 'Sales Agent',
      marketReviews: 'Market Reviews',
      certificates: 'Certificates',
      dataIntegration: 'Data Integrations',
    },
    hero: {
      author: 'Author',
      authors: 'Authors',
    },
    search: {
      startSearch: 'Search',
      placeholder: 'Search for a company or person',
      clearFields: 'Clear search',
      companies: 'Companies',
      persons: 'Persons',
      all: 'All',
      articles: 'Articles',
      result: ' search results',
      description:
        'NB! Displaying up to 10,000 results. Please refine your filter selection. The file contains up to 10,000 entries. Please refine your filter selection. Data includes: person’s name, date of birth, gender, personal contacts, associated company name, registration code, activity field, company contacts, revenue, operating profit, and number of employees',
      sendRequest: 'Submit inquiry',
      viewFileExample: 'View sample (.xlsx)',
      noPersonResults: '0 results for person search {{query}} ... perform a new search!',
      noCompanyResults: '0 results for company search {{query}} ... perform a new search!',
      companyName: 'Company name',
      registrationCode: 'Reg. code',
      headerResults: 'results for search',
      backToSearch: 'Back to search results',
      formerName: 'former name',
    },
    header: {
      login: 'Log in',
      logout: 'Log out',
    },
    footer: {
      findUs: 'Find us {{label}}',
    },
    applicationForm: {
      title: 'Application form',
      firstname: 'First name',
      surname: 'Last name',
      phone: 'Phone',
      email: 'Email',
      message: 'Message (cover letter)',
      addCv: 'Add CV (docx, PDF)',
      cancel: 'Cancel',
      send: 'Submit',
      required: 'Required',
      success: 'Application submitted',
      close: 'Close notification',
      addFiles: 'Add files',
    },
    askOffer: {
      close: 'Close notification',
      send: 'Gold package offer sent',
      title: 'Please leave your contact details, we will get in touch with you soon',
      subtitle: 'The trial period comes with a free Infobank demo so you can get the most out of it.',
      success: 'Your inquiry has been sent to us!',
      error: 'An error occurred while sending data. Please review the fields.',
      name: 'First and last name',
      required: 'Required',
      phone: 'Phone',
      email: 'Email',
      info: 'Topic of interest',
      message: 'Message',
      button: 'Submit',
      options: {
        credit: 'Credit Information',
        marketing: 'Marketing Lists',
        other: 'Other',
        select: 'Select category',
      },
      validation: {
        wrongPhone: 'Invalid number',
        wrongPhoneNumber: 'Numbers only',
        wrongEmail: 'Invalid email format',
      },
    },
    breadcrumbs: {
      frontpage: 'Homepage',
      search: 'Search',
      blog: 'Blog',
      account: 'Account',
    },
    article: {
      readMore: 'Read more',
    },
    controlMulti: {
      selectCategory: 'Select all in category',
    },
    companyChart: {
      allFilters: 'All filters',
      showSecondStageRelations: 'Show second stage relations',
      applyFilters: 'Apply filters',
      showBeneficiaries: 'Show beneficiaries',
    },
    notFound: {
      title: 'Page not found',
      description: 'The page you are looking for is no longer available',
      back: 'Go to the homepage',
    },
    error: {
      title: 'Something went wrong',
      description: 'The action could not be completed. Please try again in a moment.',
    },
    serverError: {
      title: 'Something went wrong',
      description: 'An unexpected error occurred while loading the page. Please try again later.',
    },
    moduleError: {
      title: 'Something went wrong',
      description: 'An unexpected error occurred while loading the module. Please try again later.',
    },
    table: {
      showHistory: 'Show history',
      hideHistory: 'Hide history',
    },
    paywall: {
      text: 'To download the credit report, you need to be logged in as a Gold Package user',
      addDebt: 'To add a debt claim, you need to be logged in as a Gold Package user',
      monitoring: 'To add a company to the monitoring list, you need to be logged in as a Gold Package user',
      limitMonitoring:
        'Your monitoring list capacity is full. If you need to increase the limit, please let us know at <a href="mailto:info@infopank.ee">info@infopank.ee</a>',
      downloadLimit:
        'Your download limit for this month has been reached. If you wish to adjust the limits, please contact us at <a href="mailto:info@infopank.ee">info@infopank.ee</a>',
      button: 'Activate gold package',
    },
    blog: {
      title: 'Blog',
      button: 'View all blog posts',
    },
    share: {
      email: 'E-mail',
      link: 'Link',
    },
  },
  company: {
    dataNotLoaded: 'Failed to load data',
    tryAgain: 'Try again',
    addDebt: 'Add debt',
    creditReport: 'Credit report',
    creditReportExample: 'View sample report',
    removeMonitoring: 'Remove from monitoring',
    addMonitoring: 'Add to monitoring',
    success: 'Done!',
    removed: 'Company removed from monitoring',
    added: 'Company added to monitoring',
    news: 'News',
    articleNews: 'Information notices',
    noNews: 'The company has not appeared in Äripäev news',
    sections: {
      'general': 'General Info',
      'business-relations': 'Business Relations',
      'business-analytics': 'Business Analytics',
      'swot-analysis': 'SWOT Analysis',
      'tax-report': 'Tax Report',
      'debt-registry': 'Debt Registry',
      'other-info': 'Other info',
    },
    pdf: {
      view: 'View',
      download: 'Download',
    },
    chart: {
      connectionsLimit: 'Too many business connections to create a chart. Please adjust the filters.',
    },
    businessAnalyticsComparison: {
      subtitle: "Compare the company's financial indicators with other selected companies.",
      compareWith: 'Compare with a company',
      searchPlaceholder: 'Search for a company',
      inComparison: 'In comparison',
      clearComparison: 'Clear comparison',
      removeFromComparison: 'Remove {{name}} from comparison',
      mainCompanyBadge: 'Main company',
      quarterlyRevenue: 'Quarterly revenue',
      employeeCount: 'Number of employees',
      revenuePerEmployee: 'Revenue per employee',
      averageMonthlyWage: 'Average monthly wage',
      loadingComparisonData: 'Loading comparison data...',
    },
    download: {
      result: '{{total}} search results',
      description:
        'NB! Displaying up to {{maxRowsInExport}} results. Please refine your filter selection. The file contains up to {{maxRowsInExport}} entries. Please refine your filter selection.',
      limit: 'NB! To download files, pop-up windows must be enabled in the browser! File limit: {{limit}} Remaining balance: {{stock}}',
      save: 'Save results (.csv)',
    },
    filter: {
      personAudience: 'Key personnel target group',
      companyAudience: 'Company target group',
      relatedToPerson: 'Filters for companies associated with the person',
      listOfCompanies: 'Create a list of companies',
      viewAll: 'Select all',
      keyPerson: 'Key personnel filters',
      relationship: 'Relationship with company',
      areaResponsibility: 'Responsibility field',
      belongs: 'Belonging to business top rankings',
      numberEmployee: 'Number of employees',
      from: 'From',
      to: 'To',
      location: 'Location',
      establishDate: 'Establishment date',
      legalForm: 'Legal form of the company',
      profitLoss: 'Operating profit/loss',
      fieldActivity: 'Activity field',
      searchFieldActivity: 'Enter the desired activity field',
      revenue: 'Revenue',
    },
    creditReportComponent: {
      description:
        '<p>The credit report includes the following information and is printable:</p><ul><li>Credit rating and recommended credit limit</li><li>Debt information: tax arrears, claims in the Infopank debt register, payment orders, enforcement notices, asset seizures</li><li>Company general information, contact details</li><li>Responsible persons (management board)</li><li>Other related persons (owners, supervisory board members, founder, auditor, key employees)</li><li>Balance sheet, income statement, and cash flow statement from the latest available annual report</li><li>Quarterly financial results: revenue, number of employees, taxes paid</li><li>Related news and inclusion in Äripäev rankings</li></ul><p>The report is generated in real-time based on the latest data. Please be patient as creating the report in real-time may take a few seconds.</p>',
    },
  },
  person: {
    noNews: 'The person has not appeared in Äripäev news',
    sections: {
      'overview': 'Information Card',
      'business-relations': 'Business Relations',
      'work-history': 'Work History',
      'news': 'News',
    },
    table: {
      name: 'Name',
      birthday: 'Date of birth',
    },
  },
  account: {
    myAccount: 'My account',
    monitoringCompanyList: 'Monitored companies',
    monitoringEvents: 'Monitoring events',
    companyName: 'Company name',
    selfService: 'Self-service',
    selfServiceDescription: 'In business self-service, you can edit your account information, manage orders, add/remove access, etc.',
    selfServiceButton: 'Enter self-service',
    noMonitoringEventsTitle: 'No events!',
    noMonitoringEventsDescription:
      'Once you have added your important competitors, clients, and partners to the monitoring list, this is where you\'ll find the latest updates about those companies in the future. Monitoring notifications will also be sent to your email. To add a company to the monitoring list, click the "Add to monitoring" button in the company view.',
  },
  toaster: {
    success: 'Done!',
    companyDeleted: 'Company removed from monitoring',
    ip: 'You are on the network {{name}} with read access. Please log in to get full access.',
    login: 'Log in',
  },
  debtForm: {
    conditions: 'Agree to the terms',
    details: 'Creditor details',
    error: 'An error occurred while sending data. Please review the fields.',
    required: 'Mandatory',
    name: 'Creditor name',
    registerCode: 'Creditor reg. code',
    contact: 'Creditor contact person',
    email: 'Creditor email',
    phoneNumber: 'Creditor phone number',
    debtDetails: 'Debtor details',
    debtName: 'Debtor name',
    debtRegisterCode: 'Debtor reg. code',
    debtTime: 'Debt creation date',
    debtTimeDescription: "NB! If the debt consists of several invoices, use the oldest invoice's due date, for example.",
    debtSum: 'Debt amount',
    debtDocuments: 'Supporting documents',
    debtDocumentFormat: 'Allowed formats: {{formats}}',
    paymentInfo: 'IMPORTANT! If the debt is settled after adding a payment default, please notify us by email.',
    paymentInfoSecond: 'The payment default will then be marked as resolved in the register.',
    agreement: {
      text: 'I agree to the <1>terms</1> of publishing payment defaults and confirm that the debt is enforceable and undisputed.',
      terms: 'terms',
    },
    cancel: 'Cancel',
    send: 'Submit',
    addedDebt: 'Debt added',
    debtDeny: 'To add a debt claim, you need to be logged in as a Gold Package user',
    activatePackage: 'Activate gold package',
    paymentConditions: 'Terms for publishing payment defaults',
    terms:
      "<p>Service provider – Äripäev AS</p><p>Client – a person who wishes to disclose their clients' debts.</p><p>The client has the right to enter information about their clients' payment defaults into the Infobank <a href=\"https://infopank.ee/\">https://infopank.ee/</a> in accordance with the requirements and rules established by the service provider.</p><p>A payment default is the client's failure to fulfill a financial obligation more than 30 (thirty) days after the payment due date. By submitting information about their clients' debts, the client confirms that the entered payment default is not disputed (no disputes exist), the debt is collectible, and the information is accurate.</p><p>The service provider has the right to refuse the entry of a payment default. Before publishing the payment default, a notification is sent to the debtor via email. After 7 days, a second email notification is sent to the debtor stating that the payment default has been published.</p><p>Complaints about the accuracy of the data must be submitted in writing to the service provider, who forwards the relevant complaint to the person who entered the disputed data. The person entering the disputed data is obliged to resolve the complaint within 14 days, notify the complainant in writing, and make the necessary changes to the data, if needed. The service provider reserves the right to delete data entered by the client if justified.</p><p>The client is responsible for the accuracy and legality of the submitted data. Any damages caused by the dissemination of incorrect data must be fully compensated by the client.</p><p>The service provider has the right at any time to limit or revoke the client's right to enter data about their clients/debtors' payment defaults into the Debt Register.</p><p>The service provider reserves the right to make changes to the procedure for entering payment defaults and, if necessary, establish additional standard conditions, which will be published on the website <a href=\"https://infopank.ee/\">https://infopank.ee/</a> and which will then become an essential part of the agreement and mandatory for the client to comply with.</p>",
  },
  certificates: {
    congratulations: 'Congratulations!',
    sorry: 'Result of the check',
    backButton: 'Back',
    qualifies: '{{companyName}} qualifies for the following certificates:',
    notQualifies: '{{companyName}} unfortunately does not qualify for Infobank certificates.',
    order: 'Order certificates',
    description: {
      html: '<p>Infobank issues the following certificates and labels to outstanding, successful, and trustworthy companies:</p><ul><li>Äripäev TOP company</li><li>Trustworthy company</li></ul>',
    },
    companyQualifies: 'See if your company qualifies for a certificate',
  },
  report: {
    extraDownload: {
      confirm: 'I agree',
      close: 'Close',
      description:
        'Your contract-defined free download limit {{maxAllowed}} has been exceeded. Each additional download costs {{price}} euros. The fee will be added to your monthly invoice.',
    },
  },
  cookie: {
    preferences: 'Cookie preferences',
  },
};

export default en;
